var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6234 18.1066L15.5805 14.0637C16.5538 12.7679 17.0793 11.1906 17.0775 9.57C17.0775 5.43039 13.7096 2.0625 9.57 2.0625C5.43039 2.0625 2.0625 5.43039 2.0625 9.57C2.0625 13.7096 5.43039 17.0775 9.57 17.0775C11.1906 17.0793 12.7679 16.5538 14.0637 15.5805L18.1066 19.6234C18.3113 19.8063 18.5782 19.904 18.8526 19.8963C19.127 19.8886 19.388 19.7762 19.5821 19.5821C19.7762 19.388 19.8886 19.127 19.8963 18.8526C19.904 18.5782 19.8063 18.3113 19.6234 18.1066ZM4.2075 9.57C4.2075 8.5094 4.52201 7.47261 5.11124 6.59075C5.70048 5.7089 6.53799 5.02157 7.51786 4.6157C8.49773 4.20982 9.57595 4.10363 10.6162 4.31054C11.6564 4.51745 12.6119 5.02818 13.3619 5.77814C14.1118 6.5281 14.6225 7.4836 14.8295 8.52383C15.0364 9.56405 14.9302 10.6423 14.5243 11.6221C14.1184 12.602 13.4311 13.4395 12.5492 14.0288C11.6674 14.618 10.6306 14.9325 9.57 14.9325C8.1483 14.9308 6.78532 14.3653 5.78002 13.36C4.77473 12.3547 4.20921 10.9917 4.2075 9.57Z",
    fill: "url(#paint0_linear_112_1283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_1283",
    x1: 10.9796,
    y1: -6.56697,
    x2: 10.9796,
    y2: 19.8967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B78520"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.b9e3e5673006e91be68ba34802782974.svg";
export { ForwardRef as ReactComponent };